module.exports = __webpack_public_path__ + "img/portrait-expressive-young-woman 1.c6a132e3.png";